export default "__VITE_ASSET__84z0XtaV__"